
const FalloConexionView = () =>
  import('../../../statics/views/FalloConexionView.vue');

export default [
  {
    path: '/FalloConexion',
    name: 'FalloConexionView',
    component: FalloConexionView,
    meta: {
      title: 'Fallo conexión',
      requiresAuthentication: false,
      requiresAuthorization: false,
      //   isSlim: true,
      bread: {
        path: [
          'Error',
        ],
      },
    },
  },
];
